import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=53f32d78&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=53f32d78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f32d78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f32d78')) {
      api.createRecord('53f32d78', component.options)
    } else {
      api.reload('53f32d78', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=53f32d78&scoped=true&", function () {
      api.rerender('53f32d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/welfareCenter/Index.vue"
export default component.exports